import React from 'react';
import PropTypes from 'prop-types';
import { Utils, translate } from 'versafleet-core';
import { connect } from 'react-redux';

const Header = ({
  account = {},
  data = [],
  strings,
}) => {
  const {
    actualWeight, volume, volumetricWeight, weightUnit, volumeUnit,
  } = Utils.Helper.calculateTaskVolumetrics(data, account);

  const dataLength = !Utils.Helper.isNullOrUndefined(data)
    ? data.filter(d => !d._destroy).length : 0;

  return (
    <div className="vf-measurement-header">

      <div className="vf-measurement-header__title">
        {`${Utils.Formatter.capitalizeFirstLetter(strings.itemPlural)} (${dataLength})`}
      </div>

      <div className="vf-measurement-header__subtitle">
        {`${strings.actualWeight}: ${Utils.Helper.roundUpToTwoDecimalPlaces(
          actualWeight,
        )} ${weightUnit} | ${strings.volume}: ${
          Utils.Helper.roundUpToTwoDecimalPlaces(volume)} ${volumeUnit} | ${
          strings.volumetricWeight} : ${
          Utils.Helper.roundUpToTwoDecimalPlaces(volumetricWeight)} ${weightUnit}`}
      </div>

    </div>
  );
};

Header.propTypes = {
  account: PropTypes.shape({}),
  data: PropTypes.arrayOf(PropTypes.shape({
    _destroy: PropTypes.bool,
  })),
  strings: PropTypes.shape({
    actualWeight: PropTypes.string,
    itemPlural: PropTypes.string,
    volumetricWeight: PropTypes.string,
    volume: PropTypes.string,
  }).isRequired,
};

const mapStateToProps = (state) => {
  const { account } = state;
  return {
    account: account.account,
  };
};

export default connect(mapStateToProps)(translate('Task.measurements')(Header));
